import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import Pagination from './Pagination';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import Cookies from "js-cookie";
import { getOwnerslistAction, getTotalOwnersListAction, OwnerDeleteAction, OwnerBlockUnBlockAction } from '../Action/action';

const Owners = () => {
	const loginData = (!Cookies.get('loginSuccessfastenerwarehouseAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessfastenerwarehouseAdmin'));
	const [OwnersList, setOwnersList] 				= useState([]);
	const [page, setPage] 							= useState(1); 
	const [totalPages, settotalPages] 				= useState(0);
	const [totalRecords, settotalRecords] 			= useState(0);
	const [pagingspinloader, setpagingspinloader] 	= useState(1);
	const [spinloader, setspinloader] 				= useState(0);	
	const [emailFilter, SetemailFilter] 			= useState('');	
	const [statusFilter, SetstatusFilter] 			= useState('');	
    useEffect(()=>{
	   setspinloader(1);
	    getTotalOwnersListAPI();
        getOwnerslist();       
    },[]);
    
     
  const getTotalOwnersListAPI = async () => {
        let res = await getTotalOwnersListAction({email:emailFilter,status:statusFilter});
        if (res.success) {
            settotalPages(res.data);
            settotalRecords(res.totalRecords);
            setpagingspinloader(0);            
		}else{
			settotalPages(0);
			settotalRecords(0);		
			setpagingspinloader(0);	
		}
    }  
  const getOwnerslist = async () => {
		let res = await getOwnerslistAction({email:emailFilter,status:statusFilter,page:page});
		if (res.success) {
			let data = res.data;			
			setOwnersList(data);	
			setspinloader(0);
		}else{
			setOwnersList([]);	
			setspinloader(0);
		}
	}
  const OwnerDelete = async (owner_id) => {
		Swal.fire({
			title: 'Are you sure? ',
			text: "Delete this owner?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText:  'Yes, delete it' 
		}).then(async (result) => {
			if (result.isConfirmed) {
				let res = await OwnerDeleteAction({'owner_id':owner_id});
				if (res.success) {
					toast.success(res.msg);
					getOwnerslist();
				} else {
					toast.error(res.msg);
				}
			}
		});
	}
  const handleStatus = async (id, is_active) => {
        Swal.fire({
			title: 'Are you sure?',
            text: is_active === 0 ? "Are you sure you want to disable this Owner?" : "Are you sure you want to enable this Owner?",
            icon: 'warning',        
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: is_active == 0 ? 'Yes, disable it' : 'Yes, enable it'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await OwnerBlockUnBlockAction({ 'id': id, 'is_active': is_active });
                if (res.success) {
                    getOwnerslist();
                    if(is_active==0)
                    toast.success("Owner disabled.");
                    else
                     toast.success("Owner enabled.");                    
                } else {
					 toast.success(res.msg);                   
                }
            }
        })
    }
  const onPageChanged = async (data)  => {
		const { currentPage, totalPages, pageLimit } = data;
		const offset = (currentPage - 1) * pageLimit;
		let res = await getOwnerslistAction({email:emailFilter,status:statusFilter,page:offset});
        if (res.success) {
            setOwnersList(res.data);
        }else{
			setOwnersList([]);	
		}
  }	
  const SetemlFilter = async (e) => {
        SetemailFilter(e.target.value);        
    }  
  const SetStFilter = async (e) => {
        SetstatusFilter(e.target.value);        
    }    
  const FilterOwners = async (e) => {
		setPage(1);	
		settotalPages(0);
		settotalRecords(0);
        getTotalOwnersListAPI();
        getOwnerslist();       
    }
  const ClearFilter = async (e) => {
	  SetemailFilter('');  
	  SetstatusFilter(''); 	       
	  setPage(1);
	  settotalPages(0);
	  settotalRecords(0);	
      let res = await getTotalOwnersListAction({email:'',status:'',role:''});
        if (res.success) {
            settotalPages(res.data);
            settotalRecords(res.totalRecords);
            setpagingspinloader(0);            
		}else{
			settotalPages(0);
			settotalRecords(0);		
			setpagingspinloader(0);	
		}
      let list = await getOwnerslistAction({email:'',status:'',page:1});
		if (list.success) {
			setOwnersList(list.data);	
		}else{
			setOwnersList([]);	
		}      
    }
    

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        
        <Header />       
        <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
               <span><a className="homelink" href={`${config.baseUrl}owners`} >Home</a></span>
              </li>
              <li className="breadcrumb-item active"><span>Owners</span></li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
        <div className="container-lg">
          <div className="row align-items-end">
            
          <div className="col-md-12">
              <div className="card mb-4">
                <div className="card-header">
					<div className="row align-items-center">				
						<div className="col-md-6 text-start">
						 <span>Owners</span>
						</div>
						<div className="col-md-6 text-end">
					 <a className="btn btn-primary createbtn" href={`${config.baseUrl}ad-owner`} ><i className="fa fa-plus"></i> Create Owner</a>
						</div>
					</div>
					<div className="row align-items-end">
						<div className="col-lg-4 mt-3 searching">	
						<label className="form-label">Owner Email</label>	
						<div className="display-flex">									 
						  <input type="text" name="email" placeholder="Search..." id="input-name" data-oc-target="autocomplete-name" className="form-control" autocomplete="off" onChange={SetemlFilter} value={emailFilter}/>
						  
							</div>
						</div>
						<div className="col-lg-2 col-md-6 mt-3">	
						<label className="form-label">Status</label>						 
							<select className="form-control" id="is_active" name="is_active" onChange={SetStFilter} value={statusFilter}>
									  <option value="">Select Status</option>								
									  <option value="1">Active</option>								
									  <option value="0">In-Active</option>								
									</select>
						</div>						
						<div className="col-lg-4 col-md-12 mt-3">
						  <button type="button" id="button-filter" className="btn btn-info" onClick={() => FilterOwners()}><i className="fa fa-search"></i> Search</button>
						  &nbsp;
						  <button type="button" id="button-filter" className="btn btn-primary" onClick={() => ClearFilter()}>Clear</button>
						</div>
					</div>	
                </div>
                
                <div className="card-body">
                
                  <div className="table-responsive">
                    <table className="table mb-0">
                      <thead className="table-light fw-semibold">
                        <tr className="align-middle table-heading">
                          <th>Sr.</th>
                          <th>Owner Name</th>
                          <th>Email</th>         
                          <th>Status</th>   
                          { loginData.role == config.role_admin ? (<><th>Action</th></>):null  }
						</tr>
                      </thead>
                      <tbody>
                        { spinloader==0 ? (
						OwnersList.length > 0  ?
							OwnersList.map((owner,index)=>{								
								return(
									<tr key={index}>
										<td>{index+1}</td>
										<td><span>{owner.first_name+' '+owner.last_name}</span></td>
										<td><span className="user-email"><Link to={`${config.baseUrl}edit-owner/` + owner.id}>{owner.email}</Link></span></td>
										<td>
										{ loginData.role == config.role_admin ? (<>
												<div className="form-check form-switch">
												  <input
													className="form-check-input"
													id={`userstatus_${index}`}
													type="checkbox"
													checked={owner.is_active === 1}
													onChange={() => handleStatus(owner.id, owner.is_active === 1 ? 0 : 1)}
												  />
											</div>
											</>):(<>
											<div className="form-check form-switch" title={owner.is_active === 1 ? 'Active' : 'In-active'}>
											  <input
												className="form-check-input"
												id={`userstatus_${index}`}
												type="checkbox"
												checked={owner.is_active === 1}
												/>
											</div>
											
											</>) }
										
										</td>	
											{ loginData.role == config.role_admin ? (<>
												<td>
													<Link to={`${config.baseUrl}edit-owner/` + owner.id}>
															<button className='btn btn-primary editbtn'><i className="far fa-edit"></i> Edit</button>
														</Link>
														&nbsp;&nbsp; 
													<button type="button" className="btn btn-primary deletebtn" onClick={() => OwnerDelete(owner.id)}><i className='fa fa-trash'></i> Delete</button>
												</td>
											</>):null }
										
										
									</tr>
								)
							})
							:
							(
								<tr><td colspan="7" className="text-center">No user found.</td></tr>
							)
						
						):
							(
								<tr><td colspan="7" className="text-center"><img className="loaderImg search-loader" src={config.baseUrl + "images/loader.gif"} height={20} width={20} /></td></tr>
							) }
                      
                      </tbody>
                    </table>
                  </div>
                   {totalPages > 0 ?										  
						 <Pagination totalRecords={totalRecords} totalPages={totalPages} pageNeighbours={page} onPageChanged={onPageChanged}   />
						 : ''
					 }	
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>    
      <Footer />
      </div>
    </>
  )

}
export default Owners;
